import { steps } from '@/mocks/steps';

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            Proces
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Jak działa Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Cztery proste kroki, które pomogą Ci odkryć i kupić najlepsze produkty.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((step, idx) => (
            <div key={idx} className="relative group">
              <div className="bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-primary-200 transition-all h-full">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-3xl font-heading font-extrabold text-background-200 select-none">
                    {step.number}
                  </span>
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                    <i className={`${step.icon} text-base`}></i>
                  </div>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.description}
                </p>
              </div>

              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-background-300 text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}